module.exports = __webpack_public_path__ + "media/images/search-icon-dc070a2f3a3409ce1617cb74411c9dc3.svg";